<h2 class="text-center mb-4">Forgot your password?</h2>
<p *ngIf="isResetError && resetMsg" class="alert alert-warning font-weight-bold text-center" role="alert">{{resetMsg}}</p>
<form [formGroup]="forgotPasswordForm" name="forgotpasswordForm" class="m-0" (ngSubmit)="OnSubmit()">
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="email" name="Email" id="Email" class="text-field" formControlName="email" autocomplete="email" required>
    <div class="formError" *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched">
      <span *ngIf="forgotPasswordForm.get('email')?.hasError('required')">Email is required</span>
      <span *ngIf="forgotPasswordForm.get('email')?.hasError('email')">Enter a valid email</span>
    </div>
  </div>
  <button *ngIf="!this.resetService.isLoading; else isLoading" type="submit" class="btn" [disabled]="this.forgotPasswordForm.invalid">Send reset link to my email</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Sending email...</button>
  </ng-template>
</form>
